module.exports = __webpack_public_path__ + "media/images/mobile/dummy04-48b473c0dfff5be3c7baa910c1e97246.jpg";